import {
  CreditorClaimTypeV3EnumDto,
  IcLookupCreditorItemDto,
} from '@data-access/bulk-operations-api';

import { IcCreditor } from '../services/ic-creditors.service';
import { createIcServiceMock } from './item-cache-service.base.mock';

const icCreditors: IcLookupCreditorItemDto[] = [
  IcLookupCreditorItemDto.fromJS({
    data: {
      name: 'Statens innkrevingssentral (straffbar handling)',
      accountNumber: '76940512057',
      claimType: CreditorClaimTypeV3EnumDto.LegalOffence,
    },
    version: 1,
    id: 'id-creditor-1',
  } as IcLookupCreditorItemDto),
  IcLookupCreditorItemDto.fromJS({
    data: {
      name: 'Skatteetaten - skatteinnkreving',
      accountNumber: '76940524802',
      claimType: CreditorClaimTypeV3EnumDto.Tax,
    },
    version: 1,
    id: 'id-creditor-2',
  } as IcLookupCreditorItemDto),
  IcLookupCreditorItemDto.fromJS({
    data: {
      name: 'User defined creditor',
      accountNumber: '76940524802',
      claimType: CreditorClaimTypeV3EnumDto.UserDefined,
    },
    version: 1,
    id: 'id-creditor-user-defined',
  } as IcLookupCreditorItemDto),
  IcLookupCreditorItemDto.fromJS({
    data: {
      name: 'Innkrevingssentralen for bidrag og tilbakebetalingskrav',
      accountNumber: '82760100435',
      claimType: CreditorClaimTypeV3EnumDto.ChildSupport,
    },
    version: 1,
    id: 'id-creditor-3',
  } as IcLookupCreditorItemDto),
  IcLookupCreditorItemDto.fromJS({
    data: {
      name: 'Statens innkrevingssentral (utleggstrekk)',
      accountNumber: '76940512057',
      claimType: CreditorClaimTypeV3EnumDto.GovernmentClaim,
    },
    version: 1,
    id: 'id-creditor-4',
  } as IcLookupCreditorItemDto),
];

function mapToLookupModel(value: IcLookupCreditorItemDto): IcCreditor {
  return {
    ...value.data,
    id: value.id,
    displayName: `${value.data.name} (${value.data.accountNumber})`,
  };
}

export function getIcCreditorsServiceMock() {
  return createIcServiceMock(icCreditors.map(mapToLookupModel), icCreditors);
}
